import { writable } from "svelte/store";
import type { SurfaceSnapshot } from "./types";
import { fetchState, getAuth } from "./api";

export type LoadState =
  | { kind: "idle" }
  | { kind: "loading" }
  | { kind: "ready"; data: SurfaceSnapshot }
  | { kind: "error"; message: string };

export const snapshot = writable<LoadState>({ kind: "idle" });

export async function loadSnapshot(opts: { fresh?: boolean } = {}): Promise<void> {
  if (!getAuth()) {
    snapshot.set({ kind: "error", message: "not_configured" });
    return;
  }
  snapshot.set({ kind: "loading" });
  try {
    const data = await fetchState(opts);
    snapshot.set({ kind: "ready", data });
  } catch (e) {
    snapshot.set({ kind: "error", message: e instanceof Error ? e.message : String(e) });
  }
}
